import {Clear} from '@mui/icons-material';
import {Box, Grid, IconButton, Stack, Typography, useTheme} from '@mui/material';
import {selectLatestRelease} from 'app/store/change/changeSlice';
import {selectAllProcesses} from 'app/store/operatingModel/operatingModelSlice';
import {PinTypes, CardType, Custom_Encode_URL} from 'app/types/Shared';
import {ArtifactCards} from 'components/ArtifactCards';
import {ArtifactCard} from 'components/ArtifactCards/ArtifactCard';
import {useSelector} from 'react-redux';

type addedProps = {
  processChanges: Array<string>;
  storybook?: boolean;
  closeCallback?: () => void;
};

const AddedProcesses = ({processChanges, storybook = false, closeCallback}: addedProps) => {
  const theme = useTheme();
  const allProcesses = useSelector(selectAllProcesses);
  const latestRelease = useSelector(selectLatestRelease);
  const newProcesses = allProcesses?.filter((p) => processChanges.includes(p.process_id));

  const formatDate = (date?: string) => {
    const month = date?.substring(4, 6);

    function getMonthName(month?: string) {
      if (month) {
        const monthNumber = parseInt(month);
        const date = new Date();
        date.setMonth(monthNumber - 1);

        return date.toLocaleString('en-US', {month: 'short'});
      }
    }

    const day = date?.substring(6, 8);
    return `(${getMonthName(month)?.toUpperCase()} ${day})`;
  };

  return (
    <Box bgcolor={theme.palette.grey[300]} boxShadow='0px 0px 5px 0px rgba(0, 0, 0, 0.25)' width='100%' p={2}>
      <Stack direction='column' spacing={1} mb={3}>
        <Stack direction='row' alignItems='center' justifyContent='flex-start'>
          <Box flexGrow={1} display='flex'>
            <Typography variant='h3'>Newly Added Processes</Typography>
          </Box>
          <IconButton sx={{p: 0}} onClick={() => closeCallback && closeCallback()}>
            <Clear fontSize='medium' sx={{color: theme.palette.grey[800]}} />
          </IconButton>
        </Stack>
        <Typography variant='h6'>{`Release ${latestRelease?.release} ${formatDate(
          latestRelease?.created_dt,
        )} includes the addition of the following processes and sub-processes:`}</Typography>
      </Stack>
      <Grid container direction='row' columnGap={2} rowGap={1}>
        {newProcesses?.map((process) => (
          <Grid item xs={12} sm={6} md={4} xl={3} key={`New-Process-${process.process_id}`} minWidth={300}>
            {storybook ? (
              <ArtifactCard
                data={{
                  id: process.id,
                  title: process.name,
                  created_dt: process.created_dt,
                  key: `LINK-${process.name.replace(' ', '-')}`,
                  url: `${window.location.origin}/process/${process.name.replace(' ', '-')}/${
                    process.operating_models_list
                  }`,
                  type: PinTypes.Process,
                  card: CardType.process,
                }}
                pinned={false}
              />
            ) : (
              <ArtifactCards
                data={{
                  id: process.id,
                  title: process.name,
                  created_dt: process.created_dt,
                  key: process.process_id,
                  url: `${window.location.origin}/process/${Custom_Encode_URL(process.name)}/${
                    process.operating_models_list
                  }`,
                  type: PinTypes.Process,
                  card: CardType.process,
                }}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default AddedProcesses;
